import $ from 'jquery';
import Exit from './Exit';

export default function NotiLogOut() {
  return (
    <>
      <div className="block-touch" id="log-out-do-container" style={{display:'flex'}}>
        <div className="center" id="log-out-do" style={{display:'inline-block', margin:'auto', color:'wheat', background:'black', border:'5px solid wheat', padding:'1em'}}>
        </div>
      </div>
      <Exit id="log-out-do-exit" className="block-touch-exit" style={{zIndex:31000, position:'fixed'}} onClick={() => $('#log-out-do-container, #log-out-do-exit').hide()}/>
    </>
  );
}
